import * as React from 'react';
import { Accordion, Button, List, Modal } from 'semantic-ui-react';

import { ModalEnfocable } from 'src/componentes/semantic-ui-extended';

export interface InfoError {
    readonly mensaje: string;
    readonly detalles?: ReadonlyArray<string>;
}

export interface ModalErrorProps extends InfoError {
    alClickearEntendido(): void;
}

export class ModalError extends React.Component<ModalErrorProps> {
    public render() {
        const { mensaje, detalles = [], alClickearEntendido } = this.props;

        return (
            <ModalEnfocable open closeOnDimmerClick={false} closeOnEscape={false}>
                <Modal.Header>Ha ocurrido un error</Modal.Header>

                <Modal.Content scrolling>
                    <p>{mensaje}</p>

                    {detalles.length > 0 && (
                        <Accordion
                            panels={[
                                {
                                    key: 'detalles',
                                    title: 'Más detalles',
                                    content: {
                                        content: (
                                            <List>
                                                {detalles.map((c, i) => (
                                                    <List.Item key={i} content={c} />
                                                ))}
                                            </List>
                                        ),
                                    },
                                },
                            ]}
                        />
                    )}
                </Modal.Content>

                <Modal.Actions>
                    <Button
                        autoFocus
                        content='Entendido'
                        icon='frown outline'
                        labelPosition='right'
                        onClick={alClickearEntendido}
                    />
                </Modal.Actions>
            </ModalEnfocable>
        );
    }
}

export default ModalError;



// WEBPACK FOOTER //
// ./src/componentes/ModalError/index.tsx